import { AppContext } from "@/context/AppContextProvider";
import { useContext } from "react";

// Placeholder hooks
const useAppContext = () => {
  const appContext = useContext(AppContext);
  if(!appContext) {
    throw new Error("useAppContext must be used within an AppContextProvider");
  }
  return appContext;
}

export default useAppContext;
